/* 單獨列傳：司馬懿傳（設計見 docs/CAMPAIGN-SIMAYI.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「simayi_」，免得和其他列傳撞名。 */
// @ts-nocheck
import simayi_xincheng from '../maps/simayi_xincheng.ts';
import simayi_wuzhang from '../maps/simayi_wuzhang.ts';
import simayi_liaodong from '../maps/simayi_liaodong.ts';
import simayi_luoyang from '../maps/simayi_luoyang.ts';
import simayi1 from '../story/simayi1.ts';
import simayi2 from '../story/simayi2.ts';
import simayi3 from '../story/simayi3.ts';
import simayi4 from '../story/simayi4.ts';

export default {
  list: { id: 'simayi', name: '司馬懿傳', years: '227–249', parts: [
    { name: '征伐篇', chapters: ['simayi-1', 'simayi-2', 'simayi-3'] },
    { name: '高平陵篇', chapters: ['simayi-4'] },
  ] },
  chapters: [simayi1, simayi2, simayi3, simayi4],
  maps: { simayi_xincheng, simayi_wuzhang, simayi_liaodong, simayi_luoyang },
};
